import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import { tierName } from '../components/subscription/tierConfig';

/**
 * THE PLAN TAG on the board ("Plus plan"): one white paper tag beside the bell, and the one click from anywhere to Plan
 * & billing. It says "plan" so it reads as a place to go, not a status. It renders only once the plan has been read —
 * it never guesses — and is hidden under 640px, where the bar has no room (workspace.css): on a phone the way is the
 * portrait → Profile's Plan row.
 */
export function HeaderPlanTag() {
  const sub = useSubscription() as Partial<ReturnType<typeof useSubscription>>;
  const { pathname } = useLocation();
  const s = sub.subscription;
  if (!s) return null;
  const name = s.display_name || tierName(s.tier, sub.allTiers);
  return (
    <Link to="/app/plan" className="br-tag br-tag--sm br-workspace-plan" aria-label={`Plan and billing — you’re on ${name}`}
      aria-current={pathname === '/app/plan' ? 'page' : undefined}>
      {name} plan
    </Link>
  );
}

/**
 * PAST DUE, said everywhere but the plan page (whose plan bar says it): Stripe is retrying, and the one thing to do is
 * update the card. Amber, because it needs the creator.
 */
export function PastDueBanner() {
  const sub = useSubscription() as Partial<ReturnType<typeof useSubscription>>;
  const { pathname } = useLocation();
  const [failed, setFailed] = useState(false);
  const s = sub.subscription;
  if (!s || s.status !== 'past_due' || pathname === '/app/plan') return null;
  const name = tierName(s.real_tier ?? s.tier, sub.allTiers);
  return (
    <div role="status" className="br-note br-note--amber br-note--straight">
      <span>Your last payment for {name} didn’t go through. Stripe will try again — update your card to keep {name}.</span>
      <button type="button" className="br-inkline" onClick={() => {
        setFailed(false);
        void sub.openCustomerPortal?.('/app/plan?from=portal').catch(() => setFailed(true));
      }}>Card &amp; invoices</button>
      {failed && <span className="br-small" role="alert">Card &amp; invoices couldn’t open. Nothing changed — try again from <Link className="br-inkline" to="/app/plan">Plan &amp; billing</Link>.</span>}
    </div>
  );
}
